export default __webpack_public_path__ + "static/media/diadora.38343544.webp";